
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 80418,
	"./src/base_page_params.ts": 80371,
	"./src/blueslip.ts": 7717,
	"./src/blueslip_stacktrace.ts": 51761,
	"./src/bot_types.ts": 41548,
	"./src/bundles/common.ts": 16004,
	"./src/bundles/marketing_page_bundle.ts": 91502,
	"./src/csrf.ts": 60737,
	"./src/loading_error.ts": 88794,
	"./src/portico/google-analytics.ts": 74024,
	"./src/portico/header.ts": 39715,
	"./src/realm_user_settings_defaults.ts": 95387,
	"./src/retry_backoff.ts": 74798,
	"./src/sentry.ts": 8308,
	"./src/state_data.ts": 63809,
	"./src/stream_types.ts": 51709,
	"./src/types.ts": 98826,
	"./src/user_settings.ts": 44514,
	"./src/user_status_types.ts": 96075,
	"./styles/portico/comparison_table.css": 95095,
	"./styles/portico/marketing_page.css": 43023,
	"./styles/portico/pricing_plans.css": 72478,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"./templates/team/contributor_count.hbs": 36993,
	"./templates/team/contributors.hbs": 10175,
	"./templates/team/loading.hbs": 22581,
	"./templates/team/total_contributor_count.hbs": 90185,
	"@sentry/conventions/attributes": 59966,
	"core-js/modules/es.array.includes.js": 66326,
	"core-js/modules/es.iterator.constructor.js": 86074,
	"core-js/modules/es.iterator.filter.js": 59238,
	"core-js/modules/es.iterator.find.js": 65919,
	"core-js/modules/es.iterator.flat-map.js": 24624,
	"core-js/modules/es.iterator.map.js": 33520,
	"core-js/modules/es.iterator.reduce.js": 24286,
	"core-js/modules/es.iterator.some.js": 71372,
	"core-js/modules/es.iterator.to-array.js": 50085,
	"core-js/modules/es.json.parse.js": 56133,
	"core-js/modules/es.json.stringify.js": 28987,
	"core-js/modules/es.map.get-or-insert-computed.js": 346,
	"core-js/modules/es.map.get-or-insert.js": 88536,
	"core-js/modules/es.set.difference.v2.js": 1501,
	"core-js/modules/es.set.intersection.v2.js": 62235,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 8206,
	"core-js/modules/es.set.is-subset-of.v2.js": 78715,
	"core-js/modules/es.set.is-superset-of.v2.js": 42972,
	"core-js/modules/es.set.symmetric-difference.v2.js": 94643,
	"core-js/modules/es.set.union.v2.js": 14303,
	"core-js/modules/es.typed-array.with.js": 97660,
	"core-js/modules/es.uint8-array.set-from-base64.js": 61687,
	"core-js/modules/es.uint8-array.set-from-hex.js": 91471,
	"core-js/modules/es.uint8-array.to-base64.js": 48605,
	"core-js/modules/es.uint8-array.to-hex.js": 67349,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"lodash": 35558,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021
};